// ad-slot — 广告位容量常量与类型。
// slot ∈ forum_list_icon | forum_list_card | article_banner。
// 容量与后端契约对齐(docs/api-list/user/ads.md)。

export const AD_CAP = {
  forum_list_icon: 20,
  forum_list_card: 4,
  article_banner: 10,
} as const

export type AdSlotType = keyof typeof AD_CAP
